import { KeyValPair } from "./common.model"

export interface MyOrganizationInfo {
  id: string
  code: string
  display_name: string
  active: boolean
  org_projects: {
    id: string
    project_id: string
    organization_id: string
  }[]
  org_project_groups: {
    id: string
    project_id: string
    organization_id: string
  }[]
  map_config: {
    center?: [number, number]
    maxBounds?: [[number, number], [number, number]]
    maxZoom?: number
    minZoom?: number
    scrollWheelZoom?: boolean
    color_mapping?: KeyValPair[]
  }
  logo: string
}

export const InitMyOrganizationInfo: MyOrganizationInfo = {
  id: "",
  code: "",
  display_name: "",
  active: false,
  org_projects: [],
  org_project_groups: [],
  map_config: {},
  logo: "",
}

export interface OrganizationInfo {
  id: string
  code: string
  display_name: string
  active: boolean
  map_config: string
  logo_url: string
}